// Let the page scroll without stepping a focused number field.
export function installNumericInputScrollGuard(target = document) {
  const onWheel = event => {
    const input = event.target
    if (input?.tagName === 'INPUT' && input.type === 'number' && target.activeElement === input) input.blur()
  }
  target.addEventListener('wheel', onWheel, { capture: true, passive: true })
  return () => target.removeEventListener('wheel', onWheel, true)
}
